import React, { useEffect, useState, useCallback } from 'react';
import { Pill, CheckCircle, Circle } from '@phosphor-icons/react';

export const MedsTab = ({ api, kid }) => {
  const [doses, setDoses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDoses = useCallback(async () => {
    try { const r = await api.get(`/kids/${kid.kid_id}/medicines/today`); setDoses(r.data); }
    catch (e) { console.error(e); }
    setLoading(false);
  }, [api, kid.kid_id]);

  useEffect(() => { setLoading(true); fetchDoses(); }, [fetchDoses]);

  const toggle = async (doseId) => {
    await api.post(`/kids/doses/${doseId}/toggle`);
    fetchDoses();
  };

  const taken = doses.filter(d => d.taken).length;

  if (loading) return <div className="flex justify-center py-12"><div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="space-y-4" data-testid="kids-meds-tab">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <p className="text-sm text-muted-foreground">
          Today's doses for {kid.name} — synced from <span className="font-medium text-foreground">Health Hub</span> medicines where "For" matches the kid's name
        </p>
        {doses.length > 0 && (
          <span className={`text-sm font-semibold px-3 py-1 rounded-full ${taken === doses.length ? 'bg-green-500/10 text-green-600' : 'bg-amber-500/10 text-amber-600'}`}>
            {taken}/{doses.length} taken
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {doses.map(d => (
          <button key={d.dose_id} onClick={() => toggle(d.dose_id)} data-testid={`dose-${d.dose_id}`}
            className={`glass-card p-4 text-left flex items-center gap-3 transition-colors ${d.taken ? 'opacity-70' : ''}`}>
            {d.taken ? <CheckCircle size={26} weight="fill" className="text-green-500 shrink-0" /> : <Circle size={26} className="text-muted-foreground shrink-0" />}
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-semibold truncate ${d.taken ? 'line-through' : ''}`}>{d.medicine_name}</p>
              <p className="text-xs text-muted-foreground">{d.dosage && `${d.dosage} · `}{d.slot}</p>
              {d.taken && d.taken_at && <p className="text-[10px] text-green-600">Taken at {new Date(d.taken_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>}
            </div>
          </button>
        ))}
      </div>

      {doses.length === 0 && (
        <div className="glass-card p-10 text-center">
          <Pill size={40} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground">No medicines assigned to <b>{kid.name}</b>.<br />
            Add a medicine in <b>Health Hub</b> with "Taken by" set to <b>{kid.name}</b> and it will appear here automatically.</p>
        </div>
      )}
    </div>
  );
};
